import { render, staticRenderFns } from "./CmgInlineLoader.vue?vue&type=template&id=5704d105&scoped=true&lang=pug&"
import script from "./cmg-inline-loader.ts?vue&type=script&lang=ts&"
export * from "./cmg-inline-loader.ts?vue&type=script&lang=ts&"
import style0 from "./CmgInlineLoader.vue?vue&type=style&index=0&id=5704d105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704d105",
  null
  
)

export default component.exports